import { useMutation } from '@tanstack/react-query'

import { generateScimAccessToken } from '@src/api'
import { DefaultApiGenerateScimAccessTokenRequest } from '@src/api/generated/iam'
import { useAxios } from '@src/hooks/use-axios'

export const useGenerateScimAccessToken = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useMutation({
    mutationFn: (params: DefaultApiGenerateScimAccessTokenRequest) =>
      generateScimAccessToken(axiosInstance, params),
  })
}
